const state = {
  componentData: {}
};

const getters = {
  getSavedState: (state) => (key) => {
    const savedState = state.componentData[key];

    return savedState ? savedState : null;
  }
};

const mutations = {
  SET_STATE(state, { key, data }) {
    state.componentData[key] = data;
  },
  CLEAR_STATE(state, key) {
    delete state.componentData[key];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
